import { render } from "./Tricube.vue?vue&type=template&id=c9fc20b0&ts=true"
import script from "./Tricube.vue?vue&type=script&lang=ts"
export * from "./Tricube.vue?vue&type=script&lang=ts"

import "./Tricube.vue?vue&type=style&index=0&id=c9fc20b0&lang=scss"

import exportComponent from "D:\\work\\h5\\2024sclh\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__